module.exports = __webpack_public_path__ + "img/cww_06.1ea24827.jpg";